import React, {useEffect, useState} from 'react';
import ObjectDataHolder from "../Hooks/ObjectDataHolder";
import Loader from "../Loader";
import AddProductSection from "../SellFactor/FactorJOZ/AddProductSection";
import SaleReturnTable from "./SaleReturnTable";
import {useLocation, useNavigate} from "react-router-dom";
import {SaleReturnData} from "./SaleReturnData";
import {prefixUrl} from "../../utils/utilsData";
import _axios from "../../httpService"
import {toast} from "react-toastify";
import FactorDatePicker from "../FactorDatePicker/FactorDatePicker";
import CustomerRLookUp from "./CustomerRLookUp";
import numericFunction from "../../utils/NumericFunction";
import TextareaCustom from "../Factor/TextareaCustom";
import FactorRLookUp from "./FactorRLookUp";
import {formatToPersianAddComma} from "../../utils/CommaSeparator";
import Swal from "sweetalert2";

const SaleReturn = () => {
  const [sendData, setSendData] = ObjectDataHolder();
  const [initialData, setInitialData] = ObjectDataHolder();
  const [componentData, setComponentData] = ObjectDataHolder();
  const [loading, setLoading] = useState(true);
  const [isSubmitButtonActive, setIsSubmitButtonActive] = useState(true)

  const myLocation = useLocation();
  const navigateTo = useNavigate()

  useEffect(() => {
    if (myLocation?.state?.id) {
      const id = myLocation?.state?.id
      if (!id) {
        toast(" مقدار آیدی تعیین نشده است.")
        return
      }
      _axios.get(prefixUrl() + "/returnFromSale/?request=saleReturnSubmittedData&saleReturnId=" + id).then(res => {
        const data = res.data;
        if (data.status) {
          setInitialData(data.data.initialData)
          setSendData(data.data.saleReturnData)
          setLoading(false)
        } else {
          toast.error(data.message)
        }
      })
    } else {
      const urlToGetInitialData = prefixUrl() + "/returnFromSale/?request=initialData";

      _axios.get(urlToGetInitialData).then(res => {
        const data = res.data;
        if (data.status) {
          // setInitialData(SaleReturnData.initialData)
          setInitialData(data.data)
          setSendData(SaleReturnData.sendData)
          setLoading(false)
        } else {
          toast.error(data.message)
          {
            setComponentData({hasAccessToStoreRoom: data.status, showMessageIfHasNotAccessToStoreRoom: data.message})
            setLoading(false)
            Swal.fire({
              title: data.message,
              text: "لطفا بعد از اعمال تغییرات مجددا تلاش کنید.",
              icon: 'error',
              showCancelButton: false,
              allowOutsideClick: false,
              showConfirmButton: true,
              confirmButtonText: 'برو به داشبورد'
            }).then((result) => {
              if (result.isConfirmed) {
                navigateTo("/dashboard")
              }
            })

          }
        }
      })


    }
  }, [])

  const submitSaleReturnHandler = (e) => {
    e.preventDefault();

    const temp = {...sendData};
    if (temp.customerId === "") {
      toast.error("لطفا یک مشتری انتخاب کنید.");
      return
    }
    if (temp.date === "") {
      toast.error("لطفا یک تاریخ انتخاب کنید.");
      return;
    }
    if (temp.tableData.length === 0) {
      toast.error("جدول جزئیات مرجوعی نمیتواند خالی باشد.");
      return;
    }
    temp.date = numericFunction.p2e(temp.date);
    const urlToSendDataToBackEnd = prefixUrl() + "/returnFromSale/"
    setIsSubmitButtonActive(false)

    toast("در حال ثبت ...")

    _axios.post(prefixUrl() + "/returnFromSale/", {
      request: "saleReturnConfirm",
      saleReturnData: temp
    }).then(res => {
      setIsSubmitButtonActive(true)

      const data = res.data;
      if (data.status) {
        setSendData(SaleReturnData.sendData);
        toast.success(data.message)
        if (sendData.mode === "edit") {
          navigateTo(-1)
        }

      } else {
        toast.error(data.message)
      }
    }).catch(err => {
      console.log(err);
      setIsSubmitButtonActive(true)
    })


  }
  return (<>
    <div className={"factor-component"}
    >
      {loading ? <Loader/> : <>
        {/*<DateAndStore*/}
        {/*  sendData={sendData} setSendData={setSendData} initialData={initialData}*/}
        {/*  componentData={componentData} setComponentData={setComponentData}*/}
        {/*/>*/}
        <>
          <div className="total">

            <h5 className="factor-title">مرجوع از فروش</h5>
            <form>
              <div className="form-control">
                <FactorDatePicker
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                />
              </div>
              <div className="form-control0">
                <CustomerRLookUp
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                />
              </div>
              <FactorRLookUp
                sendData={sendData}
                setSendData={setSendData}
                initialData={initialData}
                componentData={componentData}
                setComponentData={setComponentData}
              />

              <input
                type="text"
                className="form-control"
                placeholder="مالیات"
                value={(sendData.tax ? ("درصد مالیات :  " + formatToPersianAddComma(sendData.tax)) : "")}
                disabled={true}

              />

              {/*<SelectTypeSaleReturn*/}
              {/*  sendData={sendData}*/}
              {/*  setSendData={setSendData}*/}
              {/*  initialData={initialData}*/}
              {/*  componentData={componentData}*/}
              {/*  setComponentData={setComponentData}*/}
              {/*/>*/}
              <div className={"form-control"}>
                <TextareaCustom
                  value={sendData.description}
                  onChange={e => setSendData({description: e.target.value})}
                  placeholder={"توضیحات مرجوعی"}

                />
              </div>
              <input
                disabled={!isSubmitButtonActive}

                onClick={submitSaleReturnHandler} type="submit"
                // className="submit-btn mt-5"
                className="btnCustom btnSubmit mt-5  py-5 w-100"

                value="ثبت مرجوعی"/>

            </form>
          </div>
          <div className="total">
            <h6 className="factor-title"> جزئیات مرجوع از فروش </h6>
            <AddProductSection
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
              mode={"saleReturn"}
              storeRoomType={"showAll"}
            />
            <SaleReturnTable
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
            />
          </div>
        </>
      </>}


    </div>
  </>);
};

export default SaleReturn;
